import React from 'react';
import { Outlet } from 'react-router-dom';

import GoLabSubNav from './GoLabSubNav';

const GoLabLayout: React.FC = () => (
  <div className="flex h-full min-h-0">
    <GoLabSubNav />
    <div className="flex-1 min-w-0 overflow-auto">
      <Outlet />
    </div>
  </div>
);

export default GoLabLayout;
